import React from 'react';
import { cn } from '@/lib/utils';

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '', '0', 'back'] as const;

export function AppPinKeypad({
  disabled,
  onDigit,
  onBackspace,
}: {
  disabled?: boolean;
  onDigit: (d: string) => void;
  onBackspace: () => void;
}) {
  return (
    <div className="grid w-full grid-cols-3 gap-3 [grid-template-columns:repeat(3,minmax(0,1fr))]">
      {KEYS.map((key) => {
        if (key === '') {
          return <div key="empty" className="h-14" aria-hidden />;
        }
        const isBack = key === 'back';
        return (
          <button
            key={key}
            type="button"
            disabled={disabled}
            onClick={() => {
              if (isBack) onBackspace();
              else onDigit(key);
            }}
            className={cn(
              'flex h-14 w-full min-w-0 shrink-0 items-center justify-center whitespace-nowrap',
              'rounded-[999px] border border-border bg-background text-lg font-medium text-foreground',
              'hover:bg-accent disabled:opacity-50',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring'
            )}
            aria-label={isBack ? 'Backspace' : key}
          >
            {isBack ? '⌫' : key}
          </button>
        );
      })}
    </div>
  );
}
